import { UserReward } from '@/models/user-reward';
import { Coin } from '@starsoft/common/models';

export function getCoin(userReward?: UserReward): Coin | undefined {
  return userReward?.coin;
}
